import PrototypeHub from './PrototypeHub';

export default PrototypeHub;
